import { HttpResponse } from 'api/types'

export const downloadFile = (response: HttpResponse<string>) => {
  const fileName = response.headers
    .get('content-disposition')
    ?.split('filename=')[1]
  const url = window.URL.createObjectURL(new Blob([response.data]))
  const link = document.createElement('a')
  link.href = url
  link.setAttribute('download', fileName as string)
  document.body.appendChild(link)
  link.click()
}
